import { Component, Input } from '@angular/core';
import { InvoiceVariableStatus } from '../../../../core/interfaces/invoice-interfaces';
import { CommonModule } from '@angular/common';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
  selector: 'app-invoice-variable-status',
  standalone: true,
  imports: [CommonModule, TranslocoPipe],
  templateUrl: './invoice-variable-status.component.html',
  styleUrl: './invoice-variable-status.component.css'
})
export class InvoiceVariableStatusComponent {
  InvoiceVariableStatus = InvoiceVariableStatus;

  @Input() status?: InvoiceVariableStatus;
}
